import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mt-4 space-y-2"
}
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "pt-0" }

import { ref } from "vue";
import { Booking } from "@/types";

import AlertCard from "@/components/AlertCard.vue";
import RouterButton from "@/components/RouterButton.vue";

import api from "@/api/api";


export default /*#__PURE__*/_defineComponent({
  __name: 'ActionsCard',
  async setup(__props) {

let __temp: any, __restore: any

const actions = ref(
  {} as {
    bookings: Booking[];
  }
);

actions.value = ((
  ([__temp,__restore] = _withAsyncContext(() => api.actions.listUserActions())),
  __temp = await __temp,
  __restore(),
  __temp
)).data.actions;

return (_ctx: any,_cache: any) => {
  return (actions.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(actions.value.bookings, (booking, index) => {
          return (_openBlock(), _createBlock(AlertCard, {
            type: "warning",
            hideIcon: true,
            key: index
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('to-attend-the-booking-event-name-course-please-accept-our-mandatory-course-prerequisites', [booking.event!.name])), 1),
                _createVNode(RouterButton, {
                  to: { name: 'Course_Prerequisites', params: { id: booking.id } },
                  type: "primary"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('course-prerequisites-0')), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})